

































import { Component, Prop } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Global from '@/Global.vue'
import axios from "axios"
import { IUser } from "@/models/User"
import {apiV1UsersCurrentPath} from "@/rails/routes"

@Component({
  components: {
    Global
  }
})
export default class AuthLayout extends VueBase {
  @Prop({ type: Boolean, default: true }) readonly authLogin: boolean

  async mounted(): Promise<void> {
    if (!this.authLogin) {
      this.loading = false
      return
    }

    try {
      const res = await axios.get<IUser>(apiV1UsersCurrentPath())
      if (res.data) {
        window.location.href = '/mypage'
      } else {
        this.loading = false
      }
    } catch {
      this.loading = false
    }
  }
}
